import React from "react";
import { Info } from "lucide-react";

// PD-021: Cruise Command does not store passport images. Guidance only —
// this notice does not (and cannot) stop a passport file being chosen.
export const PASSPORT_UPLOAD_NOTICE =
  "Add booking emails, tickets and receipts. Please don't add passports — passport details are kept in Travelers.";

export function PassportUploadNotice({ testId }) {
  return (
    <p data-testid={testId} className="flex items-start gap-1.5 text-xs text-slate-600">
      <Info className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" aria-hidden="true" />
      <span>{PASSPORT_UPLOAD_NOTICE}</span>
    </p>
  );
}
